import { t } from 'commons/libs/i18n'
import { Flex, Text } from 'components'
import { theme } from 'styles/theme/hav-theme'

interface LegalNameProps {
  legalName: string
  sapCode: string
}

export const LegalName = ({ legalName, sapCode }: LegalNameProps) => {
  return (
    <Flex direction="column" gap="xs" justifyContent="center">
      <Text customColor={theme.colors.ion.neutral.strong} size="xs" weight="sm">
        {legalName}
      </Text>
      <Text customColor={theme.colors.ion.neutral.main} size="xs" weight="xsm">
        {t('common.sapCode')}: {sapCode}
      </Text>
    </Flex>
  )
}
